import { createAction } from 'redux-act';
// create update mrf action
const createUpdateMrfRequest = createAction('CREATE_UPDATE_MRF_REQUEST', data => data);
const createUpdateMrfSuccess = createAction('CREATE_UPDATE_MRF_SUCCESS', data => data);
const createUpdateMrfError = createAction('CREATE_UPDATE_MRF_ERROR');

// get-interviewer-list action
const getInterviewerListRequest = createAction('GET_INTERVIEWER_LIST_REQUEST', data => data);
const getInterviewerListSuccess = createAction('GET_INTERVIEWER_LIST_SUCCESS', data => data);
const getInterviewerListError = createAction('GET_INTERVIEWER_LIST_ERROR');

// get-mrf-by-id Actino
const getMrfDataByIdRequest = createAction('GET_MRF_DATA_BY_ID_REQUEST', data => data);
const getMrfDataByIdSuccess = createAction('GET_MRF_DATA_BY_ID_SUCCESS', data => data);
const getMrfDataByIdError = createAction('GET_MRF_DATA_BY_ID_ERROR');

// submit-draft-mrf
const submitDraftMrfRequest = createAction('GET_SUBMIT_DRAFT_MRF_REQUEST', data => data);
const submitDraftMrfSuccess = createAction('GET_SUBMIT_DRAFT_MRF_SUCCESS', data => data);
const submitDraftMrfError = createAction('GET_SUBMIT_DRAFT_MRF_ERROR');

// submit-draft-mrf
const getAllUserMrfRequest = createAction('GET_ALL_USER_MRF_REQUEST', data => data);
const getAllUserMrfSuccess = createAction('GET_ALL_USER_MRF_SUCCESS', data => data);
const getAllUserMrfError = createAction('GET_ALL_USER_MRF_ERROR');

// get mrf by id
const getMrfDashboardAndHierarchyRequest = createAction('GET_MRF_DASHBOARD_AND_HIERARCHY_REQUEST', data => data);
const getMrfDashboardAndHierarchySuccess = createAction('GET_MRF_DASHBOARD_AND_HIERARCHY_SUCCESS', data => data);
const getMrfDashboardAndHierarchyError = createAction('GET_MRF_DASHBOARD_AND_HIERARCHY_ERROR');

// get mrf by id
const getMrfForApprovalDataRequest = createAction('GET_MRF_FOR_APPROVAL_DATA_REQUEST', data => data);
const getMrfForApprovalDataSuccess = createAction('GET_MRF_FOR_APPROVAL_DATA_SUCCESS', data => data);
const getMrfForApprovalDataError = createAction('GET_MRF_FOR_APPROVAL_DATA_ERROR');

// approve-reject-mrf
const approveRejectMrfRequest = createAction('APPROVE_REJECT_MRF_REQUEST', data => data);
const approveRejectMrfSuccess = createAction('APPROVE_REJECT_MRF_SUCCESS', data => data);
const approveRejectMrfError = createAction('APPROVE_REJECT_MRF_ERROR');

// clear existing mrf action
const handleClearMrfStore = createAction('HANDLE_CLEAR_MRF_STORE',data => data);


export default {
    createUpdateMrfRequest,
    createUpdateMrfSuccess,
    createUpdateMrfError,

    getInterviewerListError,
    getInterviewerListSuccess,
    getInterviewerListRequest,

    getMrfDataByIdError,
    getMrfDataByIdSuccess,
    getMrfDataByIdRequest,

    submitDraftMrfError,
    submitDraftMrfSuccess,
    submitDraftMrfRequest,

    getAllUserMrfError,
    getAllUserMrfSuccess,
    getAllUserMrfRequest,

    getMrfDashboardAndHierarchyError,
    getMrfDashboardAndHierarchySuccess,
    getMrfDashboardAndHierarchyRequest,

    getMrfForApprovalDataError,
    getMrfForApprovalDataSuccess,
    getMrfForApprovalDataRequest,

    approveRejectMrfError,
    approveRejectMrfSuccess,
    approveRejectMrfRequest,
    
    handleClearMrfStore,

}